export const gaEvents = {
  loginSuccess: "login_success",
  loginError: "login_error",
  entityChosen: "entity_chosen",
};

export const gaCategory = "Authentication";
